import { useQuery } from "react-query";
import { QueryKeys } from "api/queryKeys";
import { fetchTimezones } from "api/fetchers/systemTimezones";
import { fetchLanguages } from "api/fetchers/systemLanguages";
import { fetchCountries } from "api/fetchers/systemCountries";

export const useTimezones = () => {
    return useQuery(QueryKeys.timezones(), fetchTimezones, {staleTime: 60*60*1000});
}

export const useLanguages = () => {
    return useQuery(QueryKeys.languages(), fetchLanguages, {staleTime: 60*60*1000});
}

export const useCountries = () => {
    return useQuery(QueryKeys.countries(), fetchCountries, {staleTime: 60*60*1000});
}